import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import {Condition} from "../../model/condition";
import {Criterion} from "../../model/criterion";
import {DragulaService} from "ng2-dragula";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
  selector: 'gen-criterion-editor',
  templateUrl: './criterion-editor.component.html',
  styleUrls: ['./criterion-editor.component.scss', '../../trial-curation-styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CriterionEditorComponent implements OnInit, OnDestroy{

  @Input() criterion: Criterion;
  @Output() cloneMe = new EventEmitter<Criterion>();
  @Output() deleteMe = new EventEmitter<Criterion>();

  // initialize the base number (as current time milliseconds) for generating unique object's ID
  private static baseIdCounter: number = performance.now();
  public listName: string = undefined;
  private destroyer$: Subject<null> = new Subject<null>();

  constructor(private dragulaService: DragulaService, private changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {
    // set a unique list's name to ensure no duplications in dragulaService's bag list
    if (!this.listName) {
      this.listName = 'condition_items_' + CriterionEditorComponent.baseIdCounter; //++;
    }

    // to use the dragulaService, it is required to call the setOptions method, specifying the container and providing
    // an object literal with your desired options
    if (! this.dragulaService.find(this.listName)) { // need to search first that name is not already added to avoid an error
      this.dragulaService.setOptions(this.listName, {
        moves: (element, container, handle) => {
          return handle.className.startsWith('fa fa-bars') && handle.parentElement.className === 'top-icons';
        },
        accepts: function(el, target, source, sibling) {
          // el - the item that is being dropped
          // target - the container on whichthe item is being dropped
          // source - the container from which the item was dragged
          // sibling - the item in the target container before which the item is being dropped, null if being dropped as last item
          return sibling !== null;
        }
      });
    }

    this.dragulaService.drop
      .pipe(
        takeUntil(this.destroyer$.asObservable())
      )
      .subscribe(data => {
        const name = data[0];
        const element = data[1];
        const target = data[2];
        const source = data[3];
        const sibling = data[4];
        //name, el, target, source, sibling

        if (name === this.listName) {
          //needed to update UI (make the dropped object stick to target area)
          this.changeDetector.markForCheck();
        }
      });
  }

  ngOnDestroy(): void {
    // remove the current list from the dragulaService's bag list
    if (this.dragulaService.find(this.listName)) { // need to search first that name exists to avoid an error
      this.dragulaService.destroy(this.listName);
    }

    this.destroyer$.next();
    this.destroyer$.complete();
    this.destroyer$.unsubscribe();
   }

  getOperator(): string {
    return this.criterion.type == "all" ? "AND" : "OR";
  }

  addCondition(): void {
    this.criterion.conditions.push(new Condition());
  }

  duplicateCondition(condition: Condition): void {
    let k = this.criterion.conditions.indexOf(condition);
    let newCondition = JSON.parse(JSON.stringify(condition));
    this.criterion.conditions.splice(k, 0, newCondition);
  }

  deleteCondition(condition: Condition): void {
    if (!this.criterion.conditions) this.criterion.conditions = [];
    this.criterion.conditions = this.criterion.conditions.filter(x => x != condition);
  }

  onCloneMe() {
    this.cloneMe.emit(this.criterion);
  }

  onDeleteMe() {
    this.deleteMe.emit(this.criterion);
  }

}
